import "./email.scss";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../state/store";
import Preview from "./preview";
import Enquiry from "../Enquiries/enquiry/enquiry";
import { GetWorkflowFromStorage, Wizard } from "../../state/workflowSlice";
import { iCommunication, iEnquiry } from "../../interfaces/iEnquiry";
import { iGenericComm, ToGenericComm } from "../../interfaces/iGenericComm";
import { useState } from "react";
import React from "react";
import { getLastCommunication, setLastCommunication } from "../../Logic/LastTouched/comm";
import { getLocalValue } from "../../utilities/localStore/calls";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../error-boundary/errorFallback";
import { defaultReset } from "../../error-boundary/logerror";
import { iLocalMessage } from "../../interfaces/emailModel";
import { updateCommunicationCache } from "../../state/communicationsCache";
import { GetEnquiryCommunications, StartUnArchiveProcess } from "../../Logic/EmsAPI/Enquiries";
import { DownloadCloud } from "react-feather";
import Processing from "../Generic/Processing";
import { ReloadActiveList } from "../../Logic/Enquiries/Load";
import { deleteItem } from "../../utilities/localStore/indexDBCalls";
import Statuses from "../../interfaces/Statuses";

type switchProps = {
    FullWidth: boolean;
    enquiry: iEnquiry;
    interface?: string;
    hasActivateWiz: boolean;
};

function Switch(props: switchProps) {
    const dispatch = useAppDispatch();
    const communicationsCache = useSelector((state: RootState) => state.CommunicationsCache);
    const [commToView, setcommToView] = useState<iGenericComm | undefined>(undefined);
    const [communications, setCommunications] = useState<iCommunication[] | undefined>(undefined);

    function changeCommToView(commId: number) {
        const comm = communications?.find(x => x.id == commId);
        if (!comm) return;

        setCommToViewF(comm);
        setLastCommunication(props.enquiry.id, commId);
    }

    const wizard = GetWorkflowFromStorage(props.enquiry?.id);

    if (wizard != undefined) {
        const localAttachments = getLocalValue<iLocalMessage[]>("localAttachments") ?? [];
        let localMessage = localAttachments?.find(x => x.communicationId == wizard.lastCommunication?.id);

        if (localMessage != undefined) {
            setCommToViewF(wizard?.lastCommunication!);
        }
    }

    React.useEffect(() => {
        const checkLastComm = async () => {
            let commsForEnquiry = communicationsCache.data.find(x => x.enquiryId == props.enquiry.id);
            // first check if there are comms...
            if (
                commsForEnquiry == undefined ||
                (commsForEnquiry && commsForEnquiry.cachedAt != props.enquiry.commUpdatedAt)
            ) {
                const commResponse = await updateComms();
                if (commResponse.data == undefined) {
                    return;
                }
                commsForEnquiry = {
                    enquiryId: props.enquiry.id,
                    communications: commResponse.data,
                    cachedAt: props.enquiry.commUpdatedAt,
                };
            }

            // get the last touched comms that was clicked by user...
            let lastCommId = getLastCommunication(props.enquiry.id);
            let lastCommunication = commsForEnquiry?.communications.find(c => c.id === lastCommId);
            if (lastCommunication) {
                setCommToViewF(lastCommunication);
            } else {
                if (
                    commsForEnquiry?.communications.find(x => x.id == commToView?.id) == undefined &&
                    commsForEnquiry &&
                    commsForEnquiry?.communications?.length > 0
                ) {
                    if (lastCommId == 0) {
                        if (commsForEnquiry?.communications?.length) {
                            lastCommId = commsForEnquiry?.communications[0].id;
                            lastCommunication = commsForEnquiry?.communications[0];
                            setCommToViewF(lastCommunication);
                        }
                    }
                }
            }
            setCommunications(commsForEnquiry.communications);
        };
        checkLastComm();
    }, [props.enquiry.id, props.enquiry.commUpdatedAt, communicationsCache]);

    React.useEffect(() => {
        if (
            communications &&
            communications.find(x => x.extractionState == "Pending" || x.extractionState == "Queued")
        ) {
            checkIfEnquiriesExtracted();
        }
    }, [communications]);

    async function updateComms() {
        let commResponse = await GetEnquiryCommunications(props.enquiry.id, 10);
        if (!commResponse.isOk) {
            throw new Error(`${commResponse.status}  ${commResponse.statusText} attempted to get comms on switch`); // the error boundary will then trap this error
        }
        if (!commResponse.data) {
            throw new Error(`${commResponse.statusText} no data returned from server when getting comms on switch`); // the error boundary will then trap this error
        }

        if (commResponse.data.find(x => x.extractionState == "Extracted")) {
            dispatch(
                updateCommunicationCache({
                    enquiryId: props.enquiry.id,
                    communications: commResponse.data,
                    cachedAt: props.enquiry.commUpdatedAt,
                }),
            );
        }
        return commResponse;
    }

    function setCommToViewF(comm: iCommunication) {
        if (comm.extractionState == "Extracted") {
            setcommToView(ToGenericComm(comm));
        } else {
            setcommToView(undefined);
        }
    }

    async function startUnArchiveProcess() {
        communications?.forEach(function (item, index) {
            deleteItem("Communications", item.id);
        });
        const response = await StartUnArchiveProcess(props.enquiry.id);
        await ReloadActiveList();
    }

    async function checkIfEnquiriesExtracted() {
        if (
            communications &&
            communications.find(x => x.extractionState == "Pending" || x.extractionState == "Queued")
        ) {
            const response = await updateComms();
            if (response.data) {
                if (response.data.find(x => x.extractionState == "Pending" || x.extractionState == "Queued")) {
                    window.setTimeout(checkIfEnquiriesExtracted, 10 * 1000);
                } else {
                    setCommunications(response.data);
                    setCommToViewF(response.data[0]);
                }
            }
        }
    }
    return (
        <>
            {Object.keys(props.enquiry).length > 0 && (
                <div className="enquiry-history">
                    <div className="enquiry-history--enquiry">
                        <ErrorBoundary
                            FallbackComponent={ErrorFallback}
                            onReset={defaultReset}
                        >
                            {communications && (
                                <Enquiry
                                    key={"key_" + props.enquiry?.id}
                                    e={props.enquiry}
                                    interface={props.interface}
                                    commOnclick={(e: number) => {
                                        changeCommToView(e);
                                    }}
                                    activeCommId={commToView?.id ?? 0}
                                    hasActivateWiz={props.hasActivateWiz}
                                    communications={communications}
                                />
                            )}
                        </ErrorBoundary>
                    </div>

                    {communications &&
                        communications?.length > 0 &&
                        commToView &&
                        communications.find(x => x.extractionState == "Archived") === undefined && (
                            <Preview
                                comm={commToView}
                                FullWidth={props.FullWidth}
                                enquirerName={props.enquiry?.enquirerName}
                                activeEnquiryId={props.enquiry.id}
                            />
                        )}
                    {communications &&
                        communications?.length > 0 &&
                        communications.find(x => x.extractionState == "Archived") && (
                            <div
                                style={{
                                    background: "white",
                                    padding: "20px",
                                    height: "100%",
                                    display: "flex",
                                    flex: "1",
                                    flexDirection: "column",
                                }}
                            >
                                <div
                                    style={{
                                        textAlign: "center",
                                        width: "100%",
                                        justifyContent: "center",
                                        height: "100%",
                                        flexDirection: "column",
                                    }}
                                >
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    This enquiry is archived.<br></br>Click below to restore full enquiry information
                                    <br />
                                    <br />
                                    <button
                                        className="g-btn g-btn-border"
                                        onClick={startUnArchiveProcess}
                                    >
                                        Restore <DownloadCloud></DownloadCloud>
                                    </button>
                                </div>
                            </div>
                        )}
                    {communications &&
                        communications?.length > 0 &&
                        commToView == undefined &&
                        communications.find(x => x.extractionState == "Pending" || x.extractionState == "Queued") && (
                            <div style={{ background: "white", padding: "20px", height: "100%" }}>
                                <Processing>
                                    <p>
                                        Processing
                                        <br />
                                        Please wait...
                                    </p>
                                </Processing>
                            </div>
                        )}
                    {communications &&
                        communications?.length == 0 &&
                        !Statuses.IsCompleted(props.enquiry.status) &&
                        props.enquiry.status != Statuses.Processing.ID && (
                            <div style={{ background: "white", padding: "20px", height: "100%" }}>
                                <Processing>
                                    <p>
                                        Processing
                                        <br />
                                        Please wait...
                                    </p>
                                </Processing>
                            </div>
                        )}
                </div>
            )}
        </>
    );
}

export default Switch;
